/* eslint-disable max-len */
export const DUTCH_TRANSLATIONS_SHARED = {
  PI: {
    'ERROR-CODE': {
      '987001':
        'Het referentienummer en/of kaartnummer komt niet voor in ons systeem.',
      '000001': 'Helaas is er iets mis gegaan, probeer het later nogmaals.',
      '000002': 'De foto is niet toegestaan, probeer een andere foto',
      '000003':
        'Uw kaartnummer en referentienummer kunnen niet gevalideerd worden.',
      '000004': 'Uw gegevens kunnen niet verwerkt worden in ons systeem.'
    }
  },
  GENERAL: {
    BUTTON: {
      CONTINUE: 'Ga Verder',
      SEND: 'Verzenden',
      'IMAGE-CHOOSE': 'Kies foto'
    },
    ERROR: 'Er is helaas iets misgegaan. Probeert u het later nog eens.'
  },
  LOCALSTORAGE: {
    TITLE: 'Waarschuwing',
    BODY: `Helaas is door de huidige browserinstelling deze pagina niet beschikbaar. Controleer of uw browser het gebruik van
    <strong>localstorage</strong> ondersteund. Neem indien nodig contact op met uw systeembeheerder.`,
    LINKS: {
      TITLE: 'Hoe nu verder?',
      HOMEPAGE: 'Ga naar de homepage',
      JOURNEY_PLANNER: 'Naar de Reisplanner',
      CUSTOMER_SERVICE: 'Vraag het bij de Klantenservice'
    }
  }
};
